import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthLayout from '../layouts/AuthLayout';


export const RoutePublic = ({
  component,
  redirect_to = '/pages',
  ...rest,
}) => {

  const { session } = rest;
  if (session.isAuthenticated === true) {
    return <Redirect to={{ pathname: redirect_to }} />;
  }

  const Component = component;
  return (
    <Route {...rest} render={(props)=>(
      <AuthLayout>
        <Component {...rest} />
      </AuthLayout>
    )} />
  );
};



// WEBPACK FOOTER //
// ./scripts/routers/RoutePublic.jsx